import { defineFcm } from '../shared/factory';

export const FCM_STRIPE_WEBHOOK_VERIFICATION_ENABLED = defineFcm('stripe_webhook_verification_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'payment-service',
		supportedGroups: { global: true },
		context: 'payment-service',
		description:
			'Enables Stripe webhook signature verification on incoming webhook events; falls back to unverified JSON parsing when disabled.',
	});
